import * as React from "react";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { OutskirtBuildingUpgrade } from "../outskirts/upgrade/OutskirtBuildingUpgrade";
export var UpgradeNursery = function () {
    return React.createElement(OutskirtBuildingUpgrade, { type: IdOutskirtBuildings.Nursery });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/UpgradeNursery.tsx
// module id = 2731
// module chunks = 3